
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired12b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired12b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b3YPz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = void 0;

var $g6VRQ = parcelRequire("g6VRQ");

var $kU0Fq = parcelRequire("kU0Fq");
var $80df293d24801362$var$VNode = /** @class */ function() {
    function VNode(_b) {
        var e_1, _c;
        var children = _b.children, meta = $g6VRQ.__rest(_b, [
            "children"
        ]);
        Object.assign(this, meta);
        try {
            for(var _d = $g6VRQ.__values(children || []), _e = _d.next(); !_e.done; _e = _d.next()){
                var vNode = _e.value;
                if (_a.isFragment(vNode)) this.children = $g6VRQ.__spreadArray($g6VRQ.__spreadArray([], $g6VRQ.__read(this.children || []), false), $g6VRQ.__read(vNode.children || []), false);
                else this.children = $g6VRQ.__spreadArray($g6VRQ.__spreadArray([], $g6VRQ.__read(this.children || []), false), [
                    vNode
                ], false);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return;
        this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, ".")),
            is && '[is="'.concat(is, '"]')
        ].filter(Boolean).join("");
    }
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $g6VRQ.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $kU0Fq.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute("is")
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== "style" && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: "class",
        htmlFor: "for"
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}();
module.exports.VNode = $80df293d24801362$var$VNode;

});
parcelRegister("g6VRQ", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $bbaa182ad3717fb0$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $bbaa182ad3717fb0$export$3c9a16f847548506);
$parcel$export(module.exports, "__exportStar", () => $bbaa182ad3717fb0$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $bbaa182ad3717fb0$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $bbaa182ad3717fb0$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $bbaa182ad3717fb0$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $bbaa182ad3717fb0$var$extendStatics = function(d, b) {
    $bbaa182ad3717fb0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bbaa182ad3717fb0$var$extendStatics(d, b);
};
function $bbaa182ad3717fb0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bbaa182ad3717fb0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bbaa182ad3717fb0$export$18ce0697a983be9b = function() {
    $bbaa182ad3717fb0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbaa182ad3717fb0$export$18ce0697a983be9b.apply(this, arguments);
};
function $bbaa182ad3717fb0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bbaa182ad3717fb0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bbaa182ad3717fb0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bbaa182ad3717fb0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bbaa182ad3717fb0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bbaa182ad3717fb0$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bbaa182ad3717fb0$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bbaa182ad3717fb0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bbaa182ad3717fb0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bbaa182ad3717fb0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bbaa182ad3717fb0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bbaa182ad3717fb0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bbaa182ad3717fb0$export$45d3717a4c69092e(o, m, p);
}
function $bbaa182ad3717fb0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bbaa182ad3717fb0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bbaa182ad3717fb0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bbaa182ad3717fb0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bbaa182ad3717fb0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bbaa182ad3717fb0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bbaa182ad3717fb0$export$10c90e4f7922046c(v) {
    return this instanceof $bbaa182ad3717fb0$export$10c90e4f7922046c ? (this.v = v, this) : new $bbaa182ad3717fb0$export$10c90e4f7922046c(v);
}
function $bbaa182ad3717fb0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bbaa182ad3717fb0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bbaa182ad3717fb0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bbaa182ad3717fb0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bbaa182ad3717fb0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bbaa182ad3717fb0$export$19a8beecd37a4c45 === "function" ? $bbaa182ad3717fb0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bbaa182ad3717fb0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bbaa182ad3717fb0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bbaa182ad3717fb0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bbaa182ad3717fb0$export$45d3717a4c69092e(result, mod, k);
    }
    $bbaa182ad3717fb0$var$__setModuleDefault(result, mod);
    return result;
}
function $bbaa182ad3717fb0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bbaa182ad3717fb0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bbaa182ad3717fb0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bbaa182ad3717fb0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bbaa182ad3717fb0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bbaa182ad3717fb0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bbaa182ad3717fb0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bbaa182ad3717fb0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bbaa182ad3717fb0$export$2e2bcd8739ae039 = {
    __extends: $bbaa182ad3717fb0$export$a8ba968b8961cb8a,
    __assign: $bbaa182ad3717fb0$export$18ce0697a983be9b,
    __rest: $bbaa182ad3717fb0$export$3c9a16f847548506,
    __decorate: $bbaa182ad3717fb0$export$29e00dfd3077644b,
    __param: $bbaa182ad3717fb0$export$d5ad3fd78186038f,
    __metadata: $bbaa182ad3717fb0$export$f1db080c865becb9,
    __awaiter: $bbaa182ad3717fb0$export$1050f835b63b671e,
    __generator: $bbaa182ad3717fb0$export$67ebef60e6f28a6,
    __createBinding: $bbaa182ad3717fb0$export$45d3717a4c69092e,
    __exportStar: $bbaa182ad3717fb0$export$f33643c0debef087,
    __values: $bbaa182ad3717fb0$export$19a8beecd37a4c45,
    __read: $bbaa182ad3717fb0$export$8d051b38c9118094,
    __spread: $bbaa182ad3717fb0$export$afc72e2116322959,
    __spreadArrays: $bbaa182ad3717fb0$export$6388937ca91ccae8,
    __spreadArray: $bbaa182ad3717fb0$export$1216008129fb82ed,
    __await: $bbaa182ad3717fb0$export$10c90e4f7922046c,
    __asyncGenerator: $bbaa182ad3717fb0$export$e427f37a30a4de9b,
    __asyncDelegator: $bbaa182ad3717fb0$export$bbd80228419bb833,
    __asyncValues: $bbaa182ad3717fb0$export$e3b29a3d6162315f,
    __makeTemplateObject: $bbaa182ad3717fb0$export$4fb47efe1390b86f,
    __importStar: $bbaa182ad3717fb0$export$c21735bcef00d192,
    __importDefault: $bbaa182ad3717fb0$export$da59b14a69baef04,
    __classPrivateFieldGet: $bbaa182ad3717fb0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bbaa182ad3717fb0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bbaa182ad3717fb0$export$81fdc39f203e4e04,
    __addDisposableResource: $bbaa182ad3717fb0$export$88ac25d8e944e405,
    __disposeResources: $bbaa182ad3717fb0$export$8f076105dc360e92
};

});

parcelRegister("kU0Fq", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $f3798e154fd45a4d$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $f3798e154fd45a4d$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $f3798e154fd45a4d$export$86f54f62aa7a7514);
$parcel$export(module.exports, "DiffStatus", () => $f3798e154fd45a4d$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $f3798e154fd45a4d$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $f3798e154fd45a4d$export$3f063810d7bf01bd);
$parcel$export(module.exports, "templateOf", () => $f3798e154fd45a4d$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $f3798e154fd45a4d$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $f3798e154fd45a4d$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $f3798e154fd45a4d$export$b8a1af58c024fefd);
$parcel$export(module.exports, "documentReady", () => $f3798e154fd45a4d$export$3e2b244719956741);
function $f3798e154fd45a4d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $f3798e154fd45a4d$var$$9b05bcda60cc529c$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $f3798e154fd45a4d$export$61cc6ed0f143570b;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $f3798e154fd45a4d$export$dd1bc94b04021eeb;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $f3798e154fd45a4d$export$a09f818797e212c4;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $f3798e154fd45a4d$export$170f4e08cad8229d;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $f3798e154fd45a4d$export$2a489b3f92f4996a;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $f3798e154fd45a4d$export$67a6ce548ae77071;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $f3798e154fd45a4d$export$a48f0734ac7c2329;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $f3798e154fd45a4d$export$3f34ca2fef821bbd;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $f3798e154fd45a4d$export$86f54f62aa7a7514;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $f3798e154fd45a4d$export$89912e019eef22aa;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $f3798e154fd45a4d$export$1c8ba402144543e5;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $f3798e154fd45a4d$export$2ddabb89308e1a22;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $f3798e154fd45a4d$export$14527669107aa301;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $f3798e154fd45a4d$export$3f063810d7bf01bd;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $f3798e154fd45a4d$export$b5a4d6f439a5044d;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $f3798e154fd45a4d$export$b119cc7e1840e59c;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $f3798e154fd45a4d$export$7b85fd78dd236198;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $f3798e154fd45a4d$export$697c3df919c0e61a;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $f3798e154fd45a4d$export$e6b5ff3168b5942b;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $f3798e154fd45a4d$export$1d012a0dff3dab06;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $f3798e154fd45a4d$export$69a3209f1a06c04d;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $f3798e154fd45a4d$export$86c18c6347f4a8c4;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $f3798e154fd45a4d$export$dce9414bed0662c;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $f3798e154fd45a4d$export$271f7c16f175f804;
});
var $f3798e154fd45a4d$var$$6a9944941b4c1893$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "sum", function() {
    return $f3798e154fd45a4d$export$8a63f25cc62965f1;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $f3798e154fd45a4d$export$e1f36757ecda301d;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $f3798e154fd45a4d$export$8e694e1eafd55acb;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $f3798e154fd45a4d$export$57d7c52a66287430;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $f3798e154fd45a4d$export$2b4693832ca3ce16;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $f3798e154fd45a4d$export$5b784e078da1ce6;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $f3798e154fd45a4d$export$17ec9c9f4f23588c;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $f3798e154fd45a4d$export$595dbf49c602a1f;
});
function $f3798e154fd45a4d$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $f3798e154fd45a4d$export$e1f36757ecda301d(...data) {
    return $f3798e154fd45a4d$export$8a63f25cc62965f1(...data) / data.length;
}
function $f3798e154fd45a4d$export$8e694e1eafd55acb(data, sample = false) {
    const average = $f3798e154fd45a4d$export$e1f36757ecda301d(...data);
    const summary = $f3798e154fd45a4d$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $f3798e154fd45a4d$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($f3798e154fd45a4d$export$8e694e1eafd55acb(data, sample));
}
function $f3798e154fd45a4d$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($f3798e154fd45a4d$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $f3798e154fd45a4d$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $f3798e154fd45a4d$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $f3798e154fd45a4d$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
class $f3798e154fd45a4d$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
function $f3798e154fd45a4d$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $f3798e154fd45a4d$export$dd1bc94b04021eeb(value) {
    return $f3798e154fd45a4d$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $f3798e154fd45a4d$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $f3798e154fd45a4d$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $f3798e154fd45a4d$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $f3798e154fd45a4d$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $f3798e154fd45a4d$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $f3798e154fd45a4d$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $f3798e154fd45a4d$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $f3798e154fd45a4d$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $f3798e154fd45a4d$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $f3798e154fd45a4d$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($f3798e154fd45a4d$export$2ddabb89308e1a22 || ($f3798e154fd45a4d$export$2ddabb89308e1a22 = {}));
function $f3798e154fd45a4d$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $f3798e154fd45a4d$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $f3798e154fd45a4d$export$b5a4d6f439a5044d(data) {
    if ($f3798e154fd45a4d$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $f3798e154fd45a4d$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $f3798e154fd45a4d$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($f3798e154fd45a4d$export$61cc6ed0f143570b(data)) return [];
    if ($f3798e154fd45a4d$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $f3798e154fd45a4d$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $f3798e154fd45a4d$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $f3798e154fd45a4d$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $f3798e154fd45a4d$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $f3798e154fd45a4d$export$1d012a0dff3dab06(list, iteratee) {
    const group = $f3798e154fd45a4d$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $f3798e154fd45a4d$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $f3798e154fd45a4d$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol("done"), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $f3798e154fd45a4d$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $f3798e154fd45a4d$export$271f7c16f175f804 extends $f3798e154fd45a4d$export$595dbf49c602a1f {
    constructor(...args){
        super(...args);
        this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + "B"
            }));
    }
}
var $f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $f3798e154fd45a4d$export$c489aa6f7fd82b1a;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $f3798e154fd45a4d$export$cbd942915f33be50;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $f3798e154fd45a4d$export$9b886f8493244014;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $f3798e154fd45a4d$export$e99cbb807a5bb10d;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $f3798e154fd45a4d$export$7a9a31a911eb9a20;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $f3798e154fd45a4d$export$fca4f8121099df57;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $f3798e154fd45a4d$export$6ce2f08d515512;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $f3798e154fd45a4d$export$951c8378cdfec6e6;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $f3798e154fd45a4d$export$1a4097b876a13bf7;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $f3798e154fd45a4d$export$d9bcbd5e1ff81430;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $f3798e154fd45a4d$export$506c8e8f8c8edda;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $f3798e154fd45a4d$export$3ae94a2503e890a1;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $f3798e154fd45a4d$export$62ad822b3a5fd9a0;
});
const $f3798e154fd45a4d$export$c489aa6f7fd82b1a = 1000;
const $f3798e154fd45a4d$export$cbd942915f33be50 = $f3798e154fd45a4d$export$c489aa6f7fd82b1a * 60;
const $f3798e154fd45a4d$export$9b886f8493244014 = $f3798e154fd45a4d$export$cbd942915f33be50 * 15;
const $f3798e154fd45a4d$export$e99cbb807a5bb10d = $f3798e154fd45a4d$export$9b886f8493244014 * 4;
const $f3798e154fd45a4d$export$7a9a31a911eb9a20 = $f3798e154fd45a4d$export$e99cbb807a5bb10d * 24;
const $f3798e154fd45a4d$export$fca4f8121099df57 = $f3798e154fd45a4d$export$7a9a31a911eb9a20 * 7;
const $f3798e154fd45a4d$export$6ce2f08d515512 = $f3798e154fd45a4d$export$7a9a31a911eb9a20 * 365;
const $f3798e154fd45a4d$export$951c8378cdfec6e6 = $f3798e154fd45a4d$export$6ce2f08d515512 / 12;
const $f3798e154fd45a4d$export$1a4097b876a13bf7 = $f3798e154fd45a4d$export$951c8378cdfec6e6 * 3;
class $f3798e154fd45a4d$export$d9bcbd5e1ff81430 extends $f3798e154fd45a4d$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args);
        this.units = [
            {
                base: $f3798e154fd45a4d$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $f3798e154fd45a4d$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $f3798e154fd45a4d$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $f3798e154fd45a4d$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $f3798e154fd45a4d$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $f3798e154fd45a4d$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $f3798e154fd45a4d$export$6ce2f08d515512,
                name: "Y"
            }
        ];
    }
}
function $f3798e154fd45a4d$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $f3798e154fd45a4d$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $f3798e154fd45a4d$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $f3798e154fd45a4d$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $f3798e154fd45a4d$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $f3798e154fd45a4d$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $f3798e154fd45a4d$var$$ba0e5dc395660a7c$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $f3798e154fd45a4d$export$27924e57e9afff7f;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $f3798e154fd45a4d$export$7ea17d45ecdcf634;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $f3798e154fd45a4d$export$bb8626e4916f587b;
});
function $f3798e154fd45a4d$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || $f3798e154fd45a4d$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $f3798e154fd45a4d$export$7ea17d45ecdcf634(raw) {
    const parsed = $f3798e154fd45a4d$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $f3798e154fd45a4d$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $f3798e154fd45a4d$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $f3798e154fd45a4d$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($f3798e154fd45a4d$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}
var $f3798e154fd45a4d$var$$083124ac4b1a50a0$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $f3798e154fd45a4d$export$71e6483fc2b024eb;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $f3798e154fd45a4d$export$eb9b2aadbe449a20;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $f3798e154fd45a4d$export$13397a83aa5915d6;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $f3798e154fd45a4d$export$fd89523fba250fa4;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $f3798e154fd45a4d$export$504fbde693c1771c;
});
function $f3798e154fd45a4d$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $f3798e154fd45a4d$export$eb9b2aadbe449a20(raw = window.location.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($f3798e154fd45a4d$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $f3798e154fd45a4d$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : $f3798e154fd45a4d$export$b5a4d6f439a5044d(value) ? $f3798e154fd45a4d$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
function $f3798e154fd45a4d$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$f3798e154fd45a4d$export$dd1bc94b04021eeb(value) && [
            key,
            $f3798e154fd45a4d$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $f3798e154fd45a4d$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $f3798e154fd45a4d$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $f3798e154fd45a4d$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $f3798e154fd45a4d$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $f3798e154fd45a4d$var$$50872bf213056663$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $f3798e154fd45a4d$export$1b9ac4d3de3ffd2e;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$50872bf213056663$exports, "makeSHA", function() {
    return $f3798e154fd45a4d$export$d51f3b55e8d1aa73;
});
const $f3798e154fd45a4d$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $f3798e154fd45a4d$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $f3798e154fd45a4d$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) crypto1.subtle = crypto1["webkitSubtle"];
}
async function $f3798e154fd45a4d$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
var $f3798e154fd45a4d$var$$93a3089d2937b23f$exports = {};
var $f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $f3798e154fd45a4d$export$2ee022bbbc550b25;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $f3798e154fd45a4d$export$a549dd5cef7f8327;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $f3798e154fd45a4d$export$8eece510bcb9c62c;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $f3798e154fd45a4d$export$b8a1af58c024fefd;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $f3798e154fd45a4d$export$a2cf0d4bb6e06de4;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $f3798e154fd45a4d$export$d66b332881d9723f;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $f3798e154fd45a4d$export$b0709844452f8b6b;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $f3798e154fd45a4d$export$5118471ee5d5453b;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $f3798e154fd45a4d$export$be4650432daa84fd;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $f3798e154fd45a4d$export$578e38b4a3e0b255;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $f3798e154fd45a4d$export$7cd14c57bbb84350;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $f3798e154fd45a4d$export$5100419dfae0456d;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $f3798e154fd45a4d$export$28d9d24a8cd0ffc2;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $f3798e154fd45a4d$export$3f99968195accfaf;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $f3798e154fd45a4d$export$eafdbaa868ea9975;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $f3798e154fd45a4d$export$36a0c1ca2ae264fa;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $f3798e154fd45a4d$export$86d7c59254d6a2c9;
});
const $f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$templateMap = {};
function $f3798e154fd45a4d$export$2ee022bbbc550b25(tagName) {
    if ($f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $f3798e154fd45a4d$export$a549dd5cef7f8327(tagName) {
    const node = $f3798e154fd45a4d$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $f3798e154fd45a4d$export$8eece510bcb9c62c(Class) {
    return $f3798e154fd45a4d$export$170f4e08cad8229d(Class, HTMLElement);
}
const $f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $f3798e154fd45a4d$export$b8a1af58c024fefd(Class) {
    const name = $f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $f3798e154fd45a4d$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $f3798e154fd45a4d$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $f3798e154fd45a4d$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $f3798e154fd45a4d$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $f3798e154fd45a4d$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $f3798e154fd45a4d$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($f3798e154fd45a4d$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $f3798e154fd45a4d$export$5118471ee5d5453b(node, type);
}
function $f3798e154fd45a4d$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $f3798e154fd45a4d$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $f3798e154fd45a4d$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $f3798e154fd45a4d$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $f3798e154fd45a4d$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${$f3798e154fd45a4d$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$f3798e154fd45a4d$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $f3798e154fd45a4d$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $f3798e154fd45a4d$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $f3798e154fd45a4d$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $f3798e154fd45a4d$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $f3798e154fd45a4d$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $f3798e154fd45a4d$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { type: type, name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? $f3798e154fd45a4d$export$7ea17d45ecdcf634(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$f3798e154fd45a4d$export$7ea17d45ecdcf634(value));
                break;
            case "fieldset":
                parsedValue = $f3798e154fd45a4d$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = $f3798e154fd45a4d$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$f3798e154fd45a4d$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $f3798e154fd45a4d$var$$bb23e0c794fefbef$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $f3798e154fd45a4d$export$e772c8ff12451969;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $f3798e154fd45a4d$export$57207d71b8c929c8;
});
function $f3798e154fd45a4d$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $f3798e154fd45a4d$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $f3798e154fd45a4d$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $f3798e154fd45a4d$var$$19ed8aeb7905a045$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $f3798e154fd45a4d$export$10b1921597150314;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $f3798e154fd45a4d$export$3e2b244719956741;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $f3798e154fd45a4d$export$1d1d2ed6b55cf67f;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $f3798e154fd45a4d$export$2155c0b5a4b77fb8;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $f3798e154fd45a4d$export$9d97473344489dfc;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $f3798e154fd45a4d$export$d635d04af3887bbe;
});
function $f3798e154fd45a4d$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $f3798e154fd45a4d$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $f3798e154fd45a4d$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $f3798e154fd45a4d$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $f3798e154fd45a4d$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $f3798e154fd45a4d$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $f3798e154fd45a4d$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $f3798e154fd45a4d$var$$7a08303ce13c49c5$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $f3798e154fd45a4d$export$1b88f6b6d432a52a;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $f3798e154fd45a4d$export$b70f6380221b1350;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $f3798e154fd45a4d$export$75d6cbe4503e149;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $f3798e154fd45a4d$export$b2618d51188815c2;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $f3798e154fd45a4d$export$490814474ddbb428;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $f3798e154fd45a4d$export$3ea201dffb50dfef;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $f3798e154fd45a4d$export$d1012c7198c6b460;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $f3798e154fd45a4d$export$a35a418b7b17958e;
});
class $f3798e154fd45a4d$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $f3798e154fd45a4d$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $f3798e154fd45a4d$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $f3798e154fd45a4d$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $f3798e154fd45a4d$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $f3798e154fd45a4d$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $f3798e154fd45a4d$export$75d6cbe4503e149(type, element)))
    ]);
}
function $f3798e154fd45a4d$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $f3798e154fd45a4d$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $f3798e154fd45a4d$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $f3798e154fd45a4d$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $f3798e154fd45a4d$export$490814474ddbb428(element, className, display = "block") {
    return $f3798e154fd45a4d$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $f3798e154fd45a4d$export$3ea201dffb50dfef(element, className, display = "block") {
    return $f3798e154fd45a4d$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $f3798e154fd45a4d$export$d1012c7198c6b460(element, className, remove) {
    return $f3798e154fd45a4d$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $f3798e154fd45a4d$export$a35a418b7b17958e(element, className, remove) {
    return $f3798e154fd45a4d$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $f3798e154fd45a4d$var$$69bd9f0117925302$exports = {};
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$69bd9f0117925302$exports, "describe", function() {
    return $f3798e154fd45a4d$export$cd5450f3a47e3789;
});
$f3798e154fd45a4d$var$$parcel$export($f3798e154fd45a4d$var$$69bd9f0117925302$exports, "it", function() {
    return $f3798e154fd45a4d$export$3486a10f30cf1ee4;
});
async function $f3798e154fd45a4d$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $f3798e154fd45a4d$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await $f3798e154fd45a4d$export$e772c8ff12451969(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});


parcelRegister("gH2Sk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $g6VRQ = parcelRequire("g6VRQ");

var $kU0Fq = parcelRequire("kU0Fq");

var $b3YPz = parcelRequire("b3YPz");
var $c272e475e6c0f244$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.treeCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || "") + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith("aria-") ? (0, $kU0Fq.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $kU0Fq.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $g6VRQ.__values(group[$kU0Fq.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $g6VRQ.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $g6VRQ.__values($g6VRQ.__spreadArray($g6VRQ.__spreadArray([], $g6VRQ.__read(group[$kU0Fq.DiffStatus.Same] || []), false), $g6VRQ.__read(group[$kU0Fq.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $g6VRQ.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.createNode = function(vNode, reusedVNodes) {
        var _a, _b;
        if (vNode.text) return vNode.node = document.createTextNode(vNode.text);
        var reusedVNode = vNode.selector && ((_a = reusedVNodes === null || reusedVNodes === void 0 ? void 0 : reusedVNodes[vNode.selector]) === null || _a === void 0 ? void 0 : _a.shift());
        vNode.node = vNode.tagName ? (reusedVNode === null || reusedVNode === void 0 ? void 0 : reusedVNode.node) || document.createElement(vNode.tagName, {
            is: vNode.is
        }) : document.createDocumentFragment();
        var node = this.patch(reusedVNode || {
            tagName: vNode.tagName,
            node: vNode.node
        }, vNode).node;
        if (node) (_b = vNode.ref) === null || _b === void 0 || _b.call(vNode, node);
        return node;
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChildren = function(root, newNodes) {
        var e_3, _a;
        try {
            for(var _b = $g6VRQ.__values($g6VRQ.__spreadArray([], $g6VRQ.__read(root.childNodes), false)), _c = _b.next(); !_c.done; _c = _b.next()){
                var oldNode = _c.value;
                var index = newNodes.indexOf(oldNode);
                if (index < 0) continue;
                else if (index === 0) {
                    newNodes.shift();
                    continue;
                }
                var beforeNodes = newNodes.slice(0, index);
                if (!beforeNodes[0]) continue;
                oldNode.before.apply(oldNode, $g6VRQ.__spreadArray([], $g6VRQ.__read(beforeNodes), false));
                newNodes = newNodes.slice(index + 1);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (newNodes[0]) root.append.apply(root, $g6VRQ.__spreadArray([], $g6VRQ.__read(newNodes), false));
    };
    DOMRenderer.prototype.updateChildren = function(node, oldList, newList) {
        var e_4, _a;
        var _this = this;
        var _b = (0, $kU0Fq.diffKeys)(oldList.map(this.keyOf), newList.map(this.keyOf)), map = _b.map, group = _b.group;
        var deletingGroup = group[$kU0Fq.DiffStatus.Old] && (0, $kU0Fq.groupBy)(group[$kU0Fq.DiffStatus.Old].map(function(_a) {
            var _b = $g6VRQ.__read(_a, 1), key = _b[0];
            return _this.vNodeOf(oldList, key);
        }), function(_a) {
            var selector = _a.selector;
            return selector + "";
        });
        var newNodes = newList.map(function(vNode, index) {
            var key = _this.keyOf(vNode, index);
            if (map[key] !== $kU0Fq.DiffStatus.Same) return _this.createNode(vNode, deletingGroup);
            var oldVNode = _this.vNodeOf(oldList, key);
            return vNode.text != null ? vNode.node = oldVNode.node : _this.patch(oldVNode, vNode).node;
        });
        for(var selector in deletingGroup)try {
            for(var _c = (e_4 = void 0, $g6VRQ.__values(deletingGroup[selector])), _d = _c.next(); !_d.done; _d = _c.next()){
                var vNode = _d.value;
                this.deleteNode(vNode);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.commitChildren(node, newNodes);
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVNode, newVNode) {
        var _this = this;
        var tagName = oldVNode.tagName;
        var isXML = (0, $kU0Fq.templateOf)(tagName) && (0, $kU0Fq.elementTypeOf)(tagName) === "xml";
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $kU0Fq.toHyphenCase)(key) : $b3YPz.VNode.propsMap[key] || key);
        }, function(node, key, value) {
            if (isXML || key.includes("-")) node.setAttribute(key, value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(key, value);
            }
        });
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(node, key) {
            return node.removeProperty(key);
        });
        this.updateChildren(oldVNode.node, oldVNode.children || [], newVNode.children || []);
        newVNode.node = oldVNode.node;
        return newVNode;
    };
    DOMRenderer.prototype.render = function(vNode, node) {
        if (node === void 0) node = document.body;
        var root = this.treeCache.get(node) || $b3YPz.VNode.fromDOM(node);
        root = this.patch(root, new $b3YPz.VNode($g6VRQ.__assign($g6VRQ.__assign({}, root), {
            children: [
                vNode
            ]
        })));
        this.treeCache.set(node, root);
        return root;
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        var body = document.implementation.createHTMLDocument().body;
        this.render(tree, body);
        return body.innerHTML;
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $c272e475e6c0f244$var$DOMRenderer;

});

var $cd14a4e91dfd766c$exports = {};
"use strict";
Object.defineProperty($cd14a4e91dfd766c$exports, "__esModule", {
    value: true
});
$cd14a4e91dfd766c$exports.Fragment = $cd14a4e91dfd766c$exports.jsxDEV = $cd14a4e91dfd766c$exports.jsxs = $cd14a4e91dfd766c$exports.jsx = void 0;

var $g6VRQ = parcelRequire("g6VRQ");

var $kU0Fq = parcelRequire("kU0Fq");

var $b3YPz = parcelRequire("b3YPz");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $cd14a4e91dfd766c$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $g6VRQ.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === "function" && (0, $kU0Fq.isHTMLElementClass)(type)) type = (0, $kU0Fq.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $b3YPz.VNode(node) : node === 0 || node ? new $b3YPz.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === "string" ? new $b3YPz.VNode($g6VRQ.__assign($g6VRQ.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($g6VRQ.__assign($g6VRQ.__assign({}, commonProps), props));
}
$cd14a4e91dfd766c$exports.jsx = $cd14a4e91dfd766c$var$jsx;
$cd14a4e91dfd766c$exports.jsxs = $cd14a4e91dfd766c$var$jsx;
$cd14a4e91dfd766c$exports.jsxDEV = $cd14a4e91dfd766c$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $cd14a4e91dfd766c$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $g6VRQ.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $b3YPz.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $kU0Fq.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
$cd14a4e91dfd766c$exports.Fragment = $cd14a4e91dfd766c$var$Fragment;


var $8d758228d8452b2b$exports = {};
"use strict";
Object.defineProperty($8d758228d8452b2b$exports, "__esModule", {
    value: true
});

var $g6VRQ = parcelRequire("g6VRQ");

$g6VRQ.__exportStar((parcelRequire("b3YPz")), $8d758228d8452b2b$exports);

$g6VRQ.__exportStar((parcelRequire("gH2Sk")), $8d758228d8452b2b$exports);



var $kU0Fq = parcelRequire("kU0Fq");


const $874ab4b3c36abad0$export$8b543871300e74c2 = ()=>/*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("nav", {
                className: "navbar navbar-expand-lg navbar-dark fixed-top scrolling-navbar",
                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                            className: "navbar-brand",
                            href: "#",
                            children: "3E\u5973\u5B50\u5546\u5B66\u9662"
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("button", {
                            className: "navbar-toggler",
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#Nav",
                            "aria-controls": "Nav",
                            "aria-expanded": "false",
                            "aria-label": "Toggle navigation",
                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("span", {
                                className: "navbar-toggler-icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                            className: "collapse navbar-collapse",
                            id: "Nav",
                            children: [
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("ul", {
                                    className: "navbar-nav mr-auto",
                                    children: [
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("a", {
                                                className: "nav-link",
                                                href: "#intro",
                                                children: [
                                                    "\u8BFE\u7A0B\u7B80\u4ECB",
                                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "(current)"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                className: "nav-link",
                                                href: "#teachers",
                                                children: "\u5BFC\u5E08"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                className: "nav-link",
                                                href: "#events",
                                                children: "\u7CBE\u5F69\u6D3B\u52A8"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                className: "nav-link",
                                                href: "#students",
                                                children: "\u660E\u661F\u5B66\u5458"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                className: "nav-link",
                                                href: "#gallery",
                                                children: "\u8BFE\u7A0B\u4ECB\u7ECD"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                className: "nav-link",
                                                href: "#contact",
                                                children: "\u5173\u4E8E\u6211\u4EEC & \u62A5\u540D\u54A8\u8BE2"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("ul", {
                                    className: "navbar-nav nav-flex-icons",
                                    children: [
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "nav-link",
                                                href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI4MzY0NDQxMg==&scene=126&bizpsid=0#wechat_redirect",
                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                    className: "fab fa-weixin"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "nav-link",
                                                href: "https://www.weibo.com/u/6055886285?refer_flag=1001030103_",
                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                    className: "fab fa-weibo"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                id: "intro",
                className: "view",
                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                    className: "mask rgba-black-strong",
                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                        className: "container-fluid d-flex align-items-center justify-content-center h-100",
                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                            className: "row d-flex justify-content-center text-center",
                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                className: "col-md-10",
                                children: [
                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("h2", {
                                        className: "display-4 font-weight-bold white-text pt-5 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("span", {
                                                className: "font-weight-normal",
                                                style: {
                                                    fontSize: "xx-large"
                                                },
                                                children: "\u521D\u521B\u5973\u6027"
                                            }),
                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                            "\u8BAD\u7EC3\u8425"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("hr", {
                                        className: "hr-light"
                                    }),
                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h4", {
                                        className: "white-text my-4 text-left",
                                        children: "\u901A\u8FC7\u7EBF\u4E0B\u4E3A\u671F2\u4E2A\u6708\u7684\u77ED\u671F\u8BAD\u7EC3\u8425\uFF0C\u4E0E\u540E\u671F\u966A\u4F34\u5F0F\u7684\u521B\u4E1A\u5708\u5C42\u7EC4\u7EC7\u3001 \u4E2A\u4EBA\u54A8\u8BE2\u670D\u52A1\u7684\u65B9\u5F0F\uFF0C\u63D0\u9AD8\u5973\u6027\u521B\u4E1A\u8005\u7684\u7EFC\u5408\u80FD\u529B\u3002"
                                    }),
                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                        href: "#contact",
                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("button", {
                                            type: "button",
                                            className: "btn btn-outline-white",
                                            children: [
                                                "\u4E86\u89E3\u66F4\u591A",
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                    className: "fas fa-award ml-2"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });


const $ca6b5931a253c525$export$6a3e0e8de7fede64 = ()=>/*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)((0, $cd14a4e91dfd766c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)((0, $874ab4b3c36abad0$export$8b543871300e74c2), {}),
            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("main", {
                className: "mt-5",
                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("section", {
                            id: "courses",
                            className: "text-center"
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("section", {
                            id: "teachers",
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold ",
                                    children: "\u91D1\u724C\u5BFC\u5E08\u9635\u5BB9"
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                    className: "row d-flex justify-content-center mb-4",
                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                        className: "col-md-8",
                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("p", {
                                            className: "grey-text",
                                            children: "3E\u5973\u5B50\u5546\u5B66\u9662\u7684\u5BFC\u5E08\u5747\u6765\u81EA\u672C\u571F\u5404\u884C\u4E1A\u62E5\u6709\u4E30\u5BCC\u521B\u6295\u7ECF\u9A8C\u7684\u7CBE\u82F1\uFF0C\u5E73\u5747\u76F8\u5173\u4ECE\u4E1A\u884C\u4E1A\u572810\u5E74\u4EE5\u4E0A\u3002 \u4ED6\u4EEC\u57283E\u5973\u5B50\u5546\u5B66\u9662\u7684\u4EBA\u3001\u8D22\u3001\u52A1\u7CFB\u7EDF\u8BFE\u7A0B\u4F53\u7CFB\u8BBE\u7F6E\u4E4B\u4E0B\uFF0C\u4EE5\u8F93\u51FA\u5E26\u52A8\u8F93\u5165\u7684\u7406\u5FF5\uFF0C\u5C06\u5404\u81EA\u64C5\u957F\u9886\u57DF\u7684\u601D\u7EF4\u6A21\u5F0F\u3001 \u5B9E\u6218\u7ECF\u9A8C\u6307\u5BFC\u521B\u4E1A\u5973\u6027\u8FB9\u5B66\u8FB9\u7EC3\uFF0C\u66F4\u5FEB\u66F4\u6709\u6548\u7684\u5E2E\u52A9\u5927\u5BB6\u5438\u6536\u548C\u6210\u957F\uFF0C\u4FC3\u8FDB\u9879\u76EE\u7684\u53D1\u5C55\u548C\u76C8\u5229\u3002"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                        className: "carousel slide col-md-12",
                                        "data-ride": "carousel",
                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                            className: "carousel-inner",
                                            id: "teacher",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("template", {
                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                    className: "carousel-item ${view.index ? 'active' : ''}",
                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                        className: "card-deck",
                                                        "data-view": "teachers",
                                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("template", {
                                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                                className: "card card-cascade mb-1",
                                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("img", {
                                                                    src: "img/teachers/${view.avatar}",
                                                                    alt: "teacher photo",
                                                                    className: "img-fluid"
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("section", {
                            id: "events",
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("hr", {
                                    className: "my-5"
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold ",
                                    children: "\u7CBE\u5F69\u6D3B\u52A8"
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("video", {
                                    className: "video-fluid z-depth-1",
                                    loop: true,
                                    controls: true,
                                    autoplay: true,
                                    poster: "img/poster.jpeg",
                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("source", {
                                        src: "https://media.githubusercontent.com/media/Akagilnc/Landing_Page_3EWBS/master/video/12.16%E8%87%B3%E5%8B%87%E6%96%B0%E7%94%9F.ogg",
                                        type: "video/ogg"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("section", {
                            id: "students",
                            children: [
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold text-center",
                                    children: "\u660E\u661F\u5B66\u5458"
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                    id: "student",
                                    className: "card-deck",
                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("template", {
                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                            className: "card card-cascade col-lg-4 col-md-12 mb-4",
                                            children: [
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                                    className: "view overlay z-depth-1-half",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("img", {
                                                            src: "img/students/${view.avatar}",
                                                            className: "img-fluid",
                                                            alt: "student photo"
                                                        }),
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                            className: "mask rgba-black-strong"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h4", {
                                                    className: "card-title my-3 font-weight-bold",
                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        href: "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI4MzY0NDQxMg==&scene=126&bizpsid=0#wechat_redirect",
                                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                            className: "fab fa-weixin"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("section", {
                            id: "gallery",
                            children: [
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold text-center",
                                    children: "\u8BFE\u7A0B\u4ECB\u7ECD"
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                            className: "col-md-6 mb-4",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                                id: "carousel-example-1z",
                                                className: "carousel slide carousel-fade",
                                                "data-ride": "carousel",
                                                children: [
                                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("ol", {
                                                        className: "carousel-indicators",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                                                "data-target": "#carousel-example-1z",
                                                                "data-slide-to": "0",
                                                                className: "active"
                                                            }),
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                                                "data-target": "#carousel-example-1z",
                                                                "data-slide-to": "1"
                                                            }),
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("li", {
                                                                "data-target": "#carousel-example-1z",
                                                                "data-slide-to": "2"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                                        className: "carousel-inner",
                                                        role: "listbox",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                                className: "carousel-item active",
                                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                                    href: "https://na6pe3xlrb1jajy5.mikecrm.com/q19wZQs",
                                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("img", {
                                                                        className: "d-block w-100",
                                                                        src: "img/events/\u5B98\u7F51-\u62DB\u52DF.jpg",
                                                                        alt: "First slide"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                                className: "carousel-item",
                                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                                    href: "https://www.baidu.com/s?wd=\u674E\u8BB8\u73CA\u73CA",
                                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("img", {
                                                                        className: "d-block w-100",
                                                                        src: "img/events/\u5B98\u7F51banner\u521B\u59CB\u4EBA.jpg",
                                                                        alt: "Second slide"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                                className: "carousel-item",
                                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                                    href: "https://mp.weixin.qq.com/s/xfqLOw6o8h6slB8bXV2T2w",
                                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("img", {
                                                                        className: "d-block w-100",
                                                                        src: "img/events/\u5B98\u7F51\u96C6\u9526.jpeg",
                                                                        alt: "Third slide"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                                    href: "",
                                                    className: "teal-text",
                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("h6", {
                                                        className: "pb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                                className: "fas fa-school"
                                                            }),
                                                            /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("strong", {
                                                                children: " \u521D\u521B\u5973\u6027\u8BAD\u7EC3\u8425 "
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h4", {
                                                    className: "mb-3 font-weight-bold",
                                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("strong", {
                                                        children: "\u4F60\u5C06\u83B7\u5F97"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("p", {
                                                    children: [
                                                        "\u57FA\u4E8E\u4EBA\uFF0C\u8D22\uFF0C\u52A1\uFF0C\u4ECE0\u52301\u7CFB\u7EDF\u7684\u521B\u4E1A\u9879\u76EE\u68B3\u7406",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u63D0\u5347\u5BF9\u4E2A\u4EBA\u548C\u521B\u4E1A\u8BA4\u77E5\uFF0C\u5168\u5C40\u89C2\u521B\u4E1A",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u5C11\u8D70\u5F2F\u8DEF\uFF0C\u964D\u4F4E\u7ECF\u9A8C\u4E0D\u8DB3\u5E26\u6765\u7684\u65F6\u95F4\u548C\u8D44\u91D1\u6210\u672C",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u786E\u5B9A\u4E2A\u4EBA\u521B\u4E1A\u4F18\u52BF\uFF0C\u63D0\u5347\u4E2A\u4EBA\u7EFC\u5408\u5B9E\u529B",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u6E05\u6670\u7684\u54C1\u724C\u5B9A\u4F4D\u548C\u63A8\u5E7F\u601D\u8DEF",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u5EFA\u7ACB\u5546\u4E1A\u95ED\u73AF\uFF0C\u66F4\u5FEB\u5B9E\u73B0\u76C8\u5229",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u4E2A\u4EBA\u9B45\u529B\u548C\u521B\u4E1A\u9879\u76EE\uFF0C\u57281000\u4EBA\u5927\u4F1A\u4E0A\u7684\u5C55\u793A\u673A\u4F1A",
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("br", {}),
                                                        "\u5FD7\u540C\u9053\u5408\u7684\u4F19\u4F34\uFF0C\u8BA9\u6210\u957F\u8DEF\u4E0A\u4E0D\u5B64\u5355"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("hr", {
                            className: "my-5"
                        }),
                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("section", {
                            id: "contact",
                            children: [
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h2", {
                                    className: "mb-5 font-weight-bold text-center",
                                    children: "\u8054\u7CFB\u6211\u4EEC"
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                            className: "col-lg-5 col-md-12 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("h4", {
                                                    children: "\u54A8\u8BE2\u5C0F\u52A9\u624B\u83B7\u5F97\u4E86\u89E3\u66F4\u591A"
                                                }),
                                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("img", {
                                                    src: "img/as_qrcode.jpeg",
                                                    className: "img-fluid h-75"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                            className: "col-lg-7 col-md-12",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                                id: "container",
                                                className: "z-depth-1-half map-container mb-5",
                                                style: {
                                                    height: "400px"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("div", {
                                    className: "row text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                            className: "col-lg-4 col-md-12 mb-3",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                        className: "fas fa-map fa-1x mr-2 grey-text"
                                                    }),
                                                    "\u6210\u90FD, \u56DB\u5DDD \u4E2D\u56FD"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                            className: "col-lg-4 col-md-6 mb-3",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                        className: "fas fa-building fa-1x mr-2 grey-text"
                                                    }),
                                                    "Mon - Fri, 10:00-19:00"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                            className: "col-lg-4 col-md-6 mb-3",
                                            children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsxs)("a", {
                                                    href: "tel:+8617308077367",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("i", {
                                                            className: "fas fa-phone fa-1x mr-2 grey-text"
                                                        }),
                                                        "+86 173 0807 7367"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                    className: "row text-center",
                                    children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("div", {
                                        className: "col-lg-4 col-md-6 mb-3",
                                        children: /*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)("a", {
                                            href: "http://www.beian.miit.gov.cn",
                                            children: "\u8700ICP\u590719022231\u53F7"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });


(0, $kU0Fq.documentReady).then(()=>new (0, $8d758228d8452b2b$exports.DOMRenderer)().render(/*#__PURE__*/ (0, $cd14a4e91dfd766c$exports.jsx)((0, $ca6b5931a253c525$export$6a3e0e8de7fede64), {})));


//# sourceMappingURL=index.11cfb2ed.js.map
